import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2SocioOtros } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

const TrabajadorFormGroup = ({
  iValue,
  vNombreSocio,
  setIdSocio,
  setNombreSocio,
  setIdTituloViatico,
  ocultarSections
}) => {
  const onChangeSocioHandler = pickedMember => {
    setIdSocio(pickedMember.value)
    setNombreSocio(pickedMember.label)
    ocultarSections()
    setIdTituloViatico('')

    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select-asignarDocs-tituloViatico`)
    }, 200)
  }

  const clickClear = React.useCallback(() => {
    setIdSocio('')
    setNombreSocio('')
    ocultarSections()
    setIdTituloViatico('')

    KeyEventUtil.leaveOnKeyEvent('select2-asignarDocs-trabajador')
  }, [setIdSocio, setNombreSocio, ocultarSections, setIdTituloViatico])

  React.useEffect(() => {
    setTimeout(() => {
      KeyEventUtil.leaveOnKeyEvent(`select2-asignarDocs-trabajador`)
    }, 200)
  }, [])

  return (
    <>
      <Form.Group>
        <Form.Label text='TRABAJADOR' htmlFor='input-asignarDocs-trabajador' md={4} alignRightAt='md' />
        <Col md={8}>
          {iValue ? (
            <ClearInputGroup id='input-asignarDocs-trabajador' iValue={vNombreSocio} clickClear={clickClear} />
          ) : (
            <Select2SocioOtros id='select2-asignarDocs-trabajador' onChange={onChangeSocioHandler} />
          )}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(TrabajadorFormGroup)
